import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=acaaf25e&scoped=true"
import script from "./Shares.vue?vue&type=script&lang=js"
export * from "./Shares.vue?vue&type=script&lang=js"
import style0 from "./Shares.vue?vue&type=style&index=0&id=acaaf25e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaaf25e",
  null
  
)

export default component.exports